import { BodyDropPivotTarget } from "ag-grid-community";

export interface IDonorConnectIncidentLog {
    id: number,
    actionTakenId: number,
    actionTaken: string,
    logDateTime: string,
    logDateTimeForDisplay: string,
    updateDateTime: string,
    updateDateTimeForDisplay: string,
    comments: string,
    createdBy: number,
    createdByFullName: string,
    updatedBy: number,
    updatedByFullName: string,
    isEditable: boolean,
    isDeletable: boolean,
    isPinned: boolean
}